/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResetUserPasswordConfirmRequestDto } from '../../models/reset-user-password-confirm-request-dto';

export interface ApiAuthResetUserPasswordConfirmPost$Params {
    /**
     * Oggetto contenente i dati di conferma del cambio password
     */
    body: ResetUserPasswordConfirmRequestDto;
}

export function apiAuthResetUserPasswordConfirmPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiAuthResetUserPasswordConfirmPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, apiAuthResetUserPasswordConfirmPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        }),
    );
}

apiAuthResetUserPasswordConfirmPost.PATH = '/api/auth/reset-user-password-confirm';
